const info = {
  ZH: { //中文翻译
    mustSelect: "\u8BF7\u5148\u9009\u62E9\u4E00\u4E2A\u67E5\u8BE2\u7ED3\u679C",
    correctPage: "\u8BF7\u8F93\u5165\u6B63\u786E\u9875\u7801",
    searchMds: "\u67E5\u8BE2MDS",
    symbol:'\u5185\u90E8\u6750\u6599\u53F7',
    search: "\u67E5\u627E",
    accord: "\u6309\u7167",
    asName: "\u540D\u79F0",
    asNumber: "\u6761\u76EE\u53F7",
    asSupply: "\u4F9B\u5E94\u5546",
    asCreateTime: "\u521B\u5EFA\u65F6\u95F4",
    desc: "\u964D\u5E8F",
    asc: "\u5347\u5E8F",
    order: "\u6392\u5E8F",
    confirm: "\u786E\u5B9A",
    checkout: "\u67E5\u770B",
    modify: "\u4FEE\u6539",
    copy: "\u590D\u5236",
    delete: "\u5220\u9664",
    favorite: "\u6536\u85CF",
    preview: "\u9884\u89C8",
    analyze: "\u5206\u6790",
    newSearch: "\u65B0\u7684\u67E5\u627E",
    index: "\u5E8F\u53F7",
    proName: "\u4EA7\u54C1\u540D\u79F0",
    longDes: "\u96F6\u90E8\u4EF6\u53F7,\u534A\u6210\u54C1\u4EF6\u53F7,\u6750\u6599\u53F7",
    shortDes: "\u96F6\u90E8\u4EF6\u53F7,\u534A...",
    shortDesApprove: "\u4F9B\u8D27\u7F16\u53F7",
    version: "\u7248\u672C",
    finded: "\u67E5\u8BE2\u5230",
    count: "\u6761",
    show: "\u663E\u793A",
    page: "\u9875",
    refstandard: "\u5F15\u7528\u6807\u51C6",
    createDate:"创建时间",
    receptionTime:"\u63A5\u6536\u65F6\u95F4",
    queryStandard:"查找标准",
    mdsId:'ID',
    copyHasdel:"此MDS中包含已逻辑删除的MDS,复制过程会将删除的部分从副本中移除,是否继续?",
  },
  EN: { //英文翻译
    mustSelect: "Please select a query result first!",
    correctPage: "Please input the correct Page No.",
    searchMds: "MDSs & Modules Search",
    symbol:"Internal Material No.",
    search: "Search",
    accord: "order by",
    asName: "Name",
    asNumber: "Item No.",
    asSupply: "Supplier",
    asCreateTime: "Creation date",
    desc: "Descending",
    asc: "Ascending",
    order: "Order",
    confirm: "Apply",
    checkout: "view",
    modify: "Modify",
    copy: "Copy",
    delete: "Delete",
    favorite: "Save",
    preview: "Preview",
    analyze: "Analysis",
    newSearch: "New Search",
    index: "No.",
    proName: "Article Name",
    longDes: "Part/Item No., Item- /Mat.-No., Material No.",
    shortDes: "Part/Item No...",
    shortDesApprove: "Designated Component No. by customer ",
    version: "Version",
    finded: "Search for",
    count: "Item(s)",
    show: "Display",
    page: "Pages",
    refstandard: "Reference Standard",
    createDate:'Create Date',
    receptionTime:"Reception time",
    queryStandard:"Search Criteria",
    mdsId:'ID',
    copyHasdel:"This MDS contains MDS that has been logically deleted. The replication process will remove the deleted parts from the replica. Do you want to continue?",
  }
}
export default info //需要暴露出去
